exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error-msg {\n  display: block;\n  color: red; }\n\n.new-password .col-12 {\n  padding-right: 15px;\n  padding-left: 15px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/SPA/src/app/account/asset/newPassword/newPassword-form.component.scss
// module id = ../../../../../src/app/account/asset/newPassword/newPassword-form.component.scss
// module chunks = 0